import React, { useState } from 'react';
import { UpdatePortfolio } from '../../Apis/UpdatePortfolio';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../actions/drawerActions';
import { portfolioAdded } from '../../actions/portfolioActions';
import Loader from '../../Components/Loader/Loader';
import { fetchPortfolioDetails } from '../../actions/portfolioDetailsActions';
import { handleApiError } from '../../actions/notificationActions';
import Toaster from '../../Components/Toaster/Toaster';
import TagManager from "react-gtm-module";

const EditablePortfolio = () => {

    const dispatch = useDispatch();
    const drawerData = useSelector(state => state.drawer.data);
    const portfolioDetails = drawerData.portfolioDetails;
    const [isLoading, setIsLoading] = useState(false);
    const [portfolioName, setPortfolioName] = useState(portfolioDetails.PortfolioName);
    const [portfolioId, setPortfolioId] = useState(portfolioDetails.PortfolioId)
    const [portfolioNameError, setPortfolioNameError] = useState("");
    const [quantityError, setQuantityError] = useState([]);
    const [pliDataFlag, setPliDataFlag] = useState(true);
    const [pliData, setPliData] = useState([]);
    const subscriptionsDetails = useSelector(state => state.userSubscription.subscriptionData) || {};
    const { user_type: userType, customer_id: CustomerID } = subscriptionsDetails;
    if (pliDataFlag && portfolioDetails?.PortfolioLineItem?.Hedgeable) {
        let lyst = [];
        if (Array.isArray(portfolioDetails.PortfolioLineItem.Hedgeable)) {
            for (const v of portfolioDetails.PortfolioLineItem.Hedgeable) {
                if (v?.Ticker && v?.Quantity) {
                    lyst.push({
                        'ticker': v.Ticker,
                        'oldquantity': v.Quantity,
                        'quantity': v.Quantity,
                        'companyname': v.CompanyName
                    });
                }
            }
        }
        setPliData(lyst);
        setPliDataFlag(false);
    }

    const handleInputChange = (index, key, value) => {
        const newData = [...pliData];
        newData[index][key] = value;
        setPliData(newData);
    };

    const validateEditPortfolioName = () => {
        let validFlag = true;
        let errors = {};
        let quantityErrors = [];
        let pattern = new RegExp(/^-?[0-9]\d*\.?\d*$/);
        if (!portfolioName) {
            validFlag = false;
            errors.portfolioName = "Please enter a portfolio name";
        }
        if (pliData.length !== 0) {
            pliData.forEach((row, index) => {
                if (!row.quantity) {
                    quantityErrors[index] = "Please enter quantity";
                    validFlag = false;
                } else if (!pattern.test(row.quantity)) {
                    quantityErrors[index] = "Please enter a valid quantity";
                    validFlag = false;
                } else {
                    quantityErrors[index] = null;
                }
            });
        }
        setQuantityError(quantityErrors);
        setPortfolioNameError(errors.portfolioName);
        return validFlag;
    };

    const editPortfolio = async () => {
        if (validateEditPortfolioName()) {
            setIsLoading(true);
            const payload =  pliData.map(({ oldquantity, companyname, ...rest }) => rest);
            const response = await UpdatePortfolio(portfolioId, portfolioName, payload);
            if (response.status === 200) {
                    dispatch(portfolioAdded());
                    dispatch(fetchPortfolioDetails(portfolioId));
                    dispatch(closeDrawer());
                    TagManager.dataLayer({
                        dataLayer: {
                          event: 'Update Portfolio Details',
                          userType: userType,
                          user_id: CustomerID
                        },
                      });
            } else {
                handleApiError(response, dispatch);
            }
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="toast-container">
                <Toaster />
            </div>
            <div className="drawer">
                {isLoading ? (
                    <div className="loading-overlay">
                        <Loader/>
                    </div>) : (
                    <>
                        <div className="drawer-header">
                            <button className="ai-btn mr16" onClick={() => dispatch(closeDrawer())}><img src="./Assets/home.svg"/>Dashboard</button>
                            <h1>Edit Portfolio</h1>
                            <div className="actions">
                            <button className="close-drawer" onClick={() => dispatch(closeDrawer())}>✕</button>
                            </div>
                        </div>
                        <div className='drawercontent'>
                            <div className='portfolioname'>
                                <p>Portfolio Name</p>
                                <input
                                    className='ai-form-value'
                                    type="text"
                                    placeholder="Portfolio Name"
                                    value={portfolioName}
                                    onChange={(e) => setPortfolioName(e.target.value)}
                                />
                                <p className='ai-error-message'>{portfolioNameError}</p>
                            </div>

                            <div className='tickercon'>
                                <div className="editable-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Symbol</th>
                                                <th>Position Name</th>
                                                <th>Quantity</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pliData.length > 0 ? (
                                                pliData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {row.ticker}
                                                        </td>
                                                        <td>
                                                            {row.companyname}
                                                        </td>
                                                        <td>
                                                            {row.oldquantity}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                value={row.quantity}
                                                                onChange={e => handleInputChange(index, 'quantity', e.target.value)}
                                                            />
                                                            <p className='ai-error-message'>{quantityError[index]}</p>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4">Portfolio is Empty</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='drawerbottom actions'>
                                <button className='ai-btn red solid' onClick={() => dispatch(closeDrawer())}>X Close</button>
                                <button className='ai-btn primary solid' onClick={editPortfolio}>Save</button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    )
};

export default EditablePortfolio;
